import { render, staticRenderFns } from "./AllTabsTrxSummery.vue?vue&type=template&id=70f09386"
import script from "./AllTabsTrxSummery.vue?vue&type=script&lang=js"
export * from "./AllTabsTrxSummery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports